import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ApplicationContextProvider from "./context/ApplicationContextProvider";
import ModalContextProvider from "./context/ModalContextProvider";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import LoaderContextProvider from "./context/LoaderContextProvider";
import ConfirmDialogContextProvider from "./context/ConfirmDialogContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ApplicationContextProvider>
      <ConfirmDialogContextProvider>
        <LoaderContextProvider>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            localeText={{
              fieldYearPlaceholder: (params) => "YYYY",
              fieldMonthPlaceholder: (params) =>
                params.contentType === "letter" ? "MMM" : "MM",
              fieldDayPlaceholder: () => "DD",
            }}
          >
            <ModalContextProvider>
              <App />
            </ModalContextProvider>
          </LocalizationProvider>
        </LoaderContextProvider>
      </ConfirmDialogContextProvider>
    </ApplicationContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
